// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "assets/css/" + chunkId + "." + {"427":"fe0e71d3","840":"cc202bae"}[chunkId] + ".css";
};